
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent1 as ObiWindApparent1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-1.js';
 
 
 

 
 export const ObiWindApparent1 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-1',
   elementClass: ObiWindApparent1Element,
   events: {
     
   }
  });
 
 